import moment from 'moment';

import { DEFAULT_FIXED_TIME } from '../../../constants';
import type { EdutainmentApplication } from '../../types';
import type { ScheduleSetting } from './types';

export const WAITING_REVIEW_APPLICATIONS: EdutainmentApplication[] = [
  {
    _id: '001',
    name: '創意芳香手工皂',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員'],
    category: '技藝',
    reviewDeadline: 1752249600000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 5,
    startDate: 1760198400000,
    endDate: 1775923200000,
    times: ['星期三13:00~14:00', '星期五13:00~14:00'],
    teacher: '楊淑華',
    administrator: null,
  },
  {
    _id: '002',
    name: '水彩繪畫班',
    plans: ['銀卡會員', '金卡會員'],
    category: '藝術',
    reviewDeadline: 1753459200000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 8,
    startDate: 1761408000000,
    endDate: 1777132800000,
    times: ['星期一10:00~12:00', '星期四10:00~12:00'],
    teacher: '李美玲',
    administrator: null,
  },
  {
    _id: '003',
    name: '瑜伽課程',
    plans: ['金卡會員', '鑽卡會員'],
    category: '運動',
    reviewDeadline: 1754668800000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 10,
    startDate: 1762617600000,
    endDate: 1778342400000,
    times: ['星期二09:00~10:30', '星期五09:00~10:30'],
    teacher: '張雅琪',
    administrator: null,
  },
  {
    _id: '004',
    name: '烘焙教室',
    plans: ['銀卡會員', '金卡會員', '鑽卡會員'],
    category: '烹飪',
    reviewDeadline: 1755878400000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 6,
    startDate: 1763827200000,
    endDate: 1779552000000,
    times: ['星期三15:00~17:00', '星期六15:00~17:00'],
    teacher: '王大廚',
    administrator: null,
  },
  {
    _id: '005',
    name: '英語會話班',
    plans: ['金卡會員', '鑽卡會員'],
    category: '語言',
    reviewDeadline: 1757088000000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 12,
    startDate: 1765036800000,
    endDate: 1780761600000,
    times: ['星期二19:00~20:30', '星期四19:00~20:30'],
    teacher: 'John Smith',
    administrator: null,
  },
  {
    _id: '006',
    name: '插花藝術',
    plans: ['鑽卡會員'],
    category: '技藝',
    reviewDeadline: 1758297600000,
    autoReleaseDate: null,
    status: '待審核',
    currentEnrollment: 0,
    minimumEnrollment: 4,
    startDate: 1766246400000,
    endDate: 1781971200000,
    times: ['星期六10:00~11:30', '星期日10:00~11:30'],
    teacher: '陳花藝',
    administrator: null,
  },
];

// TODO: 測試開發用，到時候改成真正值之後記得刪除
export const TEST_SCHEDULE_SETTING: ScheduleSetting = {
  fixedSchedule: Array.from({ length: 7 }, (_, index) => {
    if (index % 2 !== 0) {
      return {
        isDayChecked: true,
        startTime: moment('13:00', 'HH:mm'),
        endTime: moment('15:30', 'HH:mm'),
        place: '娛樂室',
        address: null,
      };
    }
    return DEFAULT_FIXED_TIME;
  }),
  nonFixedSchedule: [
    {
      date: null,
      startTime: null,
      endTime: null,
      place: null,
      address: null,
    },
  ],
};
